module.exports = __webpack_public_path__ + "static/media/province1.5f76bd23.png";